import { models } from "types/api/viewModels.ts";
import { Modification } from "components/NewOrders/AddModification/AddModification.tsx";
import { GetModificationsResponseData } from "types/api/products/getModifications.ts";
import { ModificationFormValues } from "components/NewOrders/AddModification/hooks/useAddModification.ts";

export const getModificationOptions = (
	singleMod: Modification | models["SpecialModificationViewModel"],
	modListIdSymbol: symbol,
	formValues: ModificationFormValues,
	modifications: GetModificationsResponseData | undefined
) => {
	const currentValue = formValues.get(singleMod[modListIdSymbol] ?? "");
	const allOptions = [currentValue, ...(modifications ?? [])].filter((mod) => mod?.id);
	const uniqueMods = new Map<string, number>();
	return allOptions.reduce<typeof allOptions>((result, mod) => {
		if (!mod?.id) return result;
		const existingIndex = uniqueMods.get(mod.id);
		if (existingIndex === undefined) {
			uniqueMods.set(mod.id, result.length);
			result.push(mod);
		} else {
			const hasRanges = "ranges" in mod && (mod.ranges?.length ?? 0) > 0;
			const existingMod = result[existingIndex];
			const existingHasRanges = existingMod && "ranges" in existingMod && (existingMod.ranges?.length ?? 0) > 0;
			if (hasRanges && !existingHasRanges) {
				result[existingIndex] = mod;
			}
		}
		return result;
	}, []);
};
